import {makeAutoObservable, reaction} from 'mobx'
import * as Api from '../utils/api/api'
import AppStore from '../stores/AppStore'
import reg from 'utils/reg'
import {searchGoods} from "../utils/api/api";
import GoodsType from "enum/GoodsType.js";

class SearchStore {
    listTypeEnum = {
        LIST: 1,
        BLOCK: 2
    }
    orderEnum = {
        ASC: 'asc',
        DESC: 'desc'
    }
    sortFieldEnum = {
        PRICE: 'currentPrice',
        SOLD_NUM: 'soldNum'
    }
    historyWordList = []
    hotWordList = []
    recommendWordList = []
    showRecommendWordList = false
    goodsList = []

    isNew = null
    isHot = null
    keyword = ''
    order = null
    sortFiled = null
    fromPrice = ''
    toPrice = ''
    pageSize = 20
    pageNum = 1
    isSpecialPrice = false
    listType = this.listTypeEnum.BLOCK
    showSelect = false
    categoryList = []
    childCategoryList = []
    currentCategory = {
        id: -1,
        optId: -1,
        isSelf: false
    }
    currentChildCategory = {
        id: -1,
        optId: -1,
        isSelf: false
    }

    hasSelfCategory = null;

    constructor() {
        makeAutoObservable(this)
    }


    get categoryId() {
        let categoryId = undefined;

        if (this.currentChildCategory.optId !== -1) {
            categoryId = this.currentChildCategory.optId
        } else if (this.currentCategory.optId !== -1) {
            categoryId = this.currentCategory.optId
        }

        return categoryId;
    }

    get realFromPrice() {
        if (reg.isNum(this.fromPrice)) {
            return Number(this.fromPrice) * 100
        } else {
            return null
        }
    }

    get realToPrice() {
        if (reg.isNum(this.toPrice)) {
            return Number(this.toPrice) * 100
        } else {
            return null
        }
    }

    get showGoodsList() {
        return this.showGoodsList && this.recommendWordList.length === 0
    }

    get selectNum() {
        let num = 0
        if (this.categoryId !== null && this.categoryId !== 0) {
            num++
        }
        if (reg.isNum(this.realFromPrice) && reg.isNum(this.realToPrice)) {
            num++
        }

        return num
    }

    /**
     * 获取历史搜索词列表
     */
    async fetchHistoryWordList() {
        try {
            if (AppStore.hasLogin) {
                const {list} = await Api.historySearchList()
                this.historyWordList = list
            }
        } catch (error) {
        }
    }

    /**
     * 获取热搜词列表
     */
    async fetchHotWordList() {
        try {
            const {list} = await Api.hotWordList({
                pageNum: 1,
                pageSize: 1000
            })

            this.hotWordList = list
        } catch (error) {
        }
    }

    /**
     * 获取推荐词列表
     * @param {*} param0
     */
    async fetchRecommendWordList({keyword}) {
        try {
            if (keyword && keyword.trim() != "") {
                const {list} = await Api.recommendWordList({
                    keyword: keyword.trim(),
                })
                this.recommendWordList = list || []
            } else {
                this.recommendWordList = []
            }

        } catch (error) {
        }
    }

    /**
     * 获取商品列表
     */

    async fetchGoodsList() {
        if (this.hasSelfCategory === null) {
            return;
        }

        try {
            this.showRecommendWordList = false
            let {
                categoryId,
                isNew,
                isHot,
                keyword,
                order,
                sortFiled,
                realFromPrice,
                realToPrice,
                pageSize,
                pageNum,
                isSpecialPrice,
                hasSelfCategory
            } = this

            let fromPrice = realFromPrice
            let toPrice = realToPrice

            if (!reg.isNum(fromPrice) || !reg.isNum(toPrice)) {
                fromPrice = null
                toPrice = null
            }

            const {list} = await Api.searchGoods({
                categoryId: undefined,
                isNew,
                isHot,
                keyword: keyword || this.currentChildCategory?.optName || this.currentCategory?.optName,
                order,
                sortFiled,
                fromPrice,
                toPrice,
                page:pageNum,
                size:pageSize,
                isSpecialPrice,
                goodsType: GoodsType.ALL
            })

            this.goodsList = list
        } catch (error) {
        }
    }

    /**
     * 切换列表类型
     */
    switchListType() {
        if (this.listType === this.listTypeEnum.LIST) {
            this.listType = this.listTypeEnum.BLOCK
        } else {
            this.listType = this.listTypeEnum.LIST
        }
    }

    /**
     * 获取类别列表
     */

    async fetchCategoryList() {
        try {
            let list = []

            const {
                list: pddGoodsCategoryList,
                hasSelfCategory
            } = await Api.pddGoodsCategoryList({
                parentId: 0
            })
            list.push(...pddGoodsCategoryList)

            this.hasSelfCategory = hasSelfCategory;
            if (hasSelfCategory) {
                list = [
                    {
                        id: 0,
                        optId: 0,
                        name: "平台自营",
                        isSelf: true
                    },
                    ...list
                ]
            }

            this.categoryList = list
        } catch (error) {
        } finally {
        }
    }

    /**
     * 获取子类别列表
     */

    async fetchChildCategoryList() {
        try {
            const {id: parentId, optId: parentOptId, isSelf} = this.currentCategory

            let list = []

            if (isSelf) {
                const {list: goodsCategoryList} = await Api.childGoodsCategoryList({
                    parentId: parentOptId
                })
                list.push(...goodsCategoryList)
            } else {

                const {
                    list: pddGoodsCategoryList,
                } = await Api.pddGoodsCategoryListByParentId({
                    parentId,
                    parentOptId
                })

                list.push(...pddGoodsCategoryList)
            }

            this.childCategoryList = list
        } catch (error) {
        }
    }


    resetSearch() {
        this.keyword = ''
        this.fromPrice = ''
        this.toPrice = ''
        this.currentCategory = {
            id: -1,
            optId: -1,
            isSelf: false,
        }
        this.currentChildCategory = {
            id: -1,
            optId: -1,
            isSelf: false,
        }
        // this.categoryId = null
        this.fromPrice = ''
        this.toPrice = ''
    }
}

const store = new SearchStore()

/**
 * 获取推荐词列表
 */
reaction(
    () => store.keyword,
    keyword => {
        if (keyword) {
            store.fetchRecommendWordList({keyword})
        }
    }
)

/**
 * 获取子类别
 */
reaction(
    () => store.currentCategory,
    currentCategory => {
        store.currentChildCategory = {
            id: -1,
            optId: -1,
            isSelf: false
        }
        if (currentCategory.optId === -1) {
            store.childCategoryList = []
        } else {
            store.fetchChildCategoryList()
        }
    }
)



export default store
